module.exports = __webpack_public_path__ + "static/media/LinkedIn.177c138c.svg";